import React from "react";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";

const cn = classNames.bind(styles);

interface IToggle {
  checked: boolean;
  label: string;
  onChange: () => void;
}

const Toggle: React.FC<IToggle> = ({ checked, label, onChange }) => (
  <label className={cn("switch")}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span className={cn("track")} />
    <span>{label}</span>
  </label>
);

export default Toggle;
